/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  drawer: Item<'Drawer'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  flexItem1: Item<'FlexItem'>;
  toolbar: Item<'Toolbar'>;
  toolbarSpacer: Item<'ToolbarSpacer'>;
  iconButton: Item<'IconButton'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  actionCloseDrawer: Item<'ActionCloseDrawer'>;
  typography: Item<'Typography'>;
  boxContainer: Item<'BoxContainer'>;
  button: Item<'Button'>;
  triggerOnClick1: Item<'TriggerOnClick'>;
  actionOpenDrawer: Item<'ActionOpenDrawer'>;
} = {
  actionCloseDrawer: {
    children: [],
    itemId: 'actionCloseDrawer',
    parent: 'triggerOnClick',
    props: {
      targetItemId: 'drawer',
    },
    type: 'ActionCloseDrawer',
  },
  actionOpenDrawer: {
    children: [],
    itemId: 'actionOpenDrawer',
    parent: 'triggerOnClick1',
    props: {
      targetItemId: 'drawer',
    },
    type: 'ActionOpenDrawer',
  },
  boxContainer: {
    children: ['button'],
    itemId: 'boxContainer',
    parent: 'root',
    props: {
      boxHeight: '100%',
    },
    type: 'BoxContainer',
  },
  button: {
    children: ['triggerOnClick1'],
    itemId: 'button',
    parent: 'boxContainer',
    props: {
      startIcon: {
        iconName: 'window-maximize',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Open Drawer',
      },
    },
    type: 'Button',
  },
  drawer: {
    children: ['flexPanel'],
    itemId: 'drawer',
    parent: 'root',
    props: {
      anchor: 'bottom',
      drawerSize: 401,
      modal: true,
    },
    type: 'Drawer',
  },
  flexItem: {
    children: ['toolbar'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {
      padding: {
        bottom: 0,
        left: 16,
        right: 16,
        top: 0,
      },
      sizeType: 'auto',
    },
    type: 'FlexItem',
  },
  flexItem1: {
    children: [],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem', 'flexItem1'],
    itemId: 'flexPanel',
    parent: 'drawer',
    props: {},
    type: 'FlexPanel',
  },
  iconButton: {
    children: ['triggerOnClick'],
    itemId: 'iconButton',
    parent: 'toolbar',
    props: {
      icon: {
        iconName: 'times',
        iconType: 'light',
      },
    },
    type: 'IconButton',
  },
  root: {
    children: ['drawer', 'boxContainer'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
  toolbar: {
    children: ['typography', 'toolbarSpacer', 'iconButton'],
    itemId: 'toolbar',
    parent: 'flexItem',
    props: {},
    type: 'Toolbar',
  },
  toolbarSpacer: {
    children: [],
    itemId: 'toolbarSpacer',
    parent: 'toolbar',
    props: {},
    type: 'ToolbarSpacer',
  },
  triggerOnClick: {
    children: ['actionCloseDrawer'],
    itemId: 'triggerOnClick',
    parent: 'iconButton',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick1: {
    children: ['actionOpenDrawer'],
    itemId: 'triggerOnClick1',
    parent: 'button',
    props: {},
    type: 'TriggerOnClick',
  },
  typography: {
    children: [],
    itemId: 'typography',
    parent: 'toolbar',
    props: {
      text: {
        type: 'text',
        value: 'Drawer',
      },
    },
    type: 'Typography',
  },
};

export const helpRenders: ComponentSample<'Drawer'>[] = [
  {
    title: 'Drawer',
    description:
      'Change the props and see the respective behaviour of the `Drawer` by clicking on the below `Open Drawer` button.',
    page,
    exampleId: 'eg-01FYTKFPQGXMD7CJM8EC5FYJ5S',
    clearParentChildren: false,
    height: 500,
    visibleProps: ['drawerSize', 'modal', 'anchor'],
    item: {
      itemId: 'drawer',
      type: 'Drawer',
      children: ['flexPanel'],
      parent: 'root',
      props: {
        open: false,
        modal: false,
      },
    },
  },
];
